// extracted by css-extract-rspack-plugin
export default {"cls1":"server_side_bulk_downloader-cls1_wM6","cls2":"server_side_bulk_downloader-cls2_Uvd server_side_bulk_downloader-cls1_wM6"};